import { createSelector } from 'reselect';
import { v2 } from '@saucelabs/sl-module-builds';

import { eventMetaDataSelector } from '../common/selectors';

export const builds = (store) => store.apps.jobs.flatBuilds.rdc;

export const automatedRDCBuildsSelector = createSelector([
  (store) => store.apps.jobs.flatBuilds.common,
  builds,
  eventMetaDataSelector,
],
(common, rdc, eventMetaData) => ({
  buildsLoading: common.get('rdcBuildsLoading'),
  rdcBuilds: rdc.get('builds'),
  rdcExpandedBuilds: rdc.get('expandedBuilds'),
  rdcFailedJobs: rdc.get('failedJobs'),
  eventMetaData: {
    ...eventMetaData,
    sku_type: 'RDC',
  },
}));

export const getUsername = v2.buildsList.selectors.createGetUsername(builds);
